import React from 'react'
import { Drawer as MuiDrawer, Toolbar } from '@mui/material'
import { styled, Theme, CSSObject } from '@mui/material/styles'
import Contents from './Contents'

const CLOSED_WIDTH = '80px'

const openedMixin = (theme: Theme, width: number): CSSObject => ({
  width: `calc(${width}px + 56px)`,

  overflow: 'auto',
  border: 'none',
})

const closedMixin = (theme: Theme, width: number): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflow: 'auto',
  border: 'none',
  borderTopLeftRadius: '20px',
  width: `calc(${CLOSED_WIDTH} + 56px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${CLOSED_WIDTH} + 56px)`,
  },
})

interface DrawerProps {
  open?: boolean
  width: number
  onOpen: () => any
  onClose: () => any
  TOP_MARGIN_MD: string
  TOP_MARGIN_SM: string
}

const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) =>
    prop !== 'open' &&
    prop !== 'width' &&
    prop !== 'onOpen' &&
    prop !== 'onClose',
})<DrawerProps>(({ width, theme, open }) => ({
  width: width,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  backgroundColor: 'transparent',
  transition: 'width  0ms',
  zIndex: 200,
  ...(open && {
    ...openedMixin(theme, width),
    '& .MuiDrawer-paper': openedMixin(theme, width),
  }),
  ...(!open && {
    ...closedMixin(theme, width),
    '& .MuiDrawer-paper': closedMixin(theme, width),
  }),
}))

export default function Drawer(props: DrawerProps) {
  const { open, width, onOpen, onClose, TOP_MARGIN_SM, TOP_MARGIN_MD } = props

  return (
    <StyledDrawer
      open={open}
      width={width}
      onOpen={onOpen}
      onClose={onClose}
      variant="permanent"
      TOP_MARGIN_SM={TOP_MARGIN_SM}
      TOP_MARGIN_MD={TOP_MARGIN_MD}
    >
      <Toolbar
        sx={{
          minHeight: { xs: TOP_MARGIN_SM, sm: TOP_MARGIN_MD, md: '113px' },
        }}
      />
      <Contents width={width} />
    </StyledDrawer>
  )
}
